/* eslint-disable */
import types from '../../types';
import date from '../../../mixins/date'

export default {
  // BOOKED PICKUP
  [types.STORE_BOOKED_PICKUPS]: (state, payload) => {
    state.bookedPickupList.items = [...state.bookedPickupList.items, ...payload.items];
    state.bookedPickupList.count = payload.count;
    state.bookedPickupList.entity = payload.entity;
  },
  [types.RESET_BOOKED_PICKUPS]: (state, payload) => {
    state.bookedPickupList.items = payload.items;
    state.bookedPickupList.count = payload.count;
    state.bookedPickupList.entity = payload.entity;
  },
  [types.CLEAR_BOOKED_PICKUPS]: (state) => {
    state.bookedPickupList.items = [];
    state.bookedPickupList.count = 0;
    state.bookedPickupList.entity = {};
  },
  [types.STORE_SINGLE_PICKUP]: (state, payload) => {
    state.singlePickup = payload;
  },
  [types.CLEAR_SINGLE_PICKUP]: (state) => {
    state.singlePickup = null;
  },
  // PICKUP SHIPMENTS
  [types.STORE_PICKUP_SHIPMENTS]: (state, payload) => {
    state.pickupShipmentsList = payload;
  },
  [types.CLEAR_NOT_PLANNED_PICKUP_SHIPMENTS]: (state) => {
    state.pickupShipmentsList.items = [];
    state.pickupShipmentsList.count = 0;
    state.pickupShipmentsList.entity = {};
  },
  [types.CLEAR_BOOKED_PICKUP_SHIPMENTS]: (state) => {
    state.pickupShipmentsList.items = [];
    state.pickupShipmentsList.count = 0;
    state.pickupShipmentsList.entity = {};
  },
  // NOT PLANNED PICKUP
  [types.STORE_NOT_PLANNED_PICKUPS]: (state, payload) => {
    state.notPlannedPickupList.items = [...state.notPlannedPickupList.items, ...payload.items].map((item) => {
      item.created_at = date.methods.formatDate(item.created_at, date.methods.defaultDateTimeFormat());
      return item;
    })
    state.notPlannedPickupList.count = payload.count;
    state.notPlannedPickupList.entity = payload.entity;
  },
  [types.RESET_NOT_PLANNED_PICKUPS]: (state, payload) => {
    state.notPlannedPickupList.items = payload.items.map((item) => {
      item.created_at = date.methods.formatDate(item.created_at, date.methods.defaultDateTimeFormat());
      return item;
    })
    state.notPlannedPickupList.count = payload.count;
    state.notPlannedPickupList.entity = payload.entity;
  },
  [types.CLEAR_NOT_PLANNED_PICKUPS]: (state) => {
    state.notPlannedPickupList.items = [];
    state.notPlannedPickupList.count = 0;
    state.notPlannedPickupList.entity = {};
  },
  //
  [types.STORE_PICKUP_LOCATIONS]: (state, payload) => {
    state.pickupLocations = payload;
  },
  [types.STORE_PICKUP_ALLOWED_FREIGHT_PRODUCTS]: (state, payload) => {
    state.pickupAllowedFreightProducts = payload;
  },
};
